// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  Property,
  TemplateStructureEnum,
  ElementPartTypeEnum,
  ComponentNameEnum,
  StepperSignEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  saveFormFieldConfig,
  setCheckboxOptionsProperty,
  setClass,
  setContactProperty,
  setContent,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  toggleClass,
  toggleShowLabelInside,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getCheckboxOptionsProperty,
  getClassByName,
  getContactProperty,
  getContentWithLineBreaks,
  getCssPropertyByName,
  hasClass,
} from '@/components/template-builder/getters';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import {
  getFormFieldContactPropertyConfig,
  getFormFieldOptionsPropertyConfig,
} from '@/components/template-builder/config/fields/form-fields-config';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import optionsLayoutFieldConfig from '@/components/template-builder/config/fields/options-layout-config';

const widgetInputCheckboxConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.inputCheckbox',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.formFields.contactProperty',
            selector: '{SELECTOR}',
            properties: [{ name: 'contactProperty', getter: getContactProperty, setters: [setContactProperty] }],
            fieldId: 'contactProperty',
            ...getFormFieldContactPropertyConfig({ typeWidget: 'inputCheckbox' }),
          },
          {
            label: 'templateBuilder.formFields.propertyOptions',
            selector: '{SELECTOR} .spm_widget_input_checkbox__options',
            properties: [{
              name: 'propertyOptions',
              type: 'checkbox',
              getter: getCheckboxOptionsProperty,
              setters: [setCheckboxOptionsProperty],
            }],
            parentFieldId: 'contactProperty',
            ...getFormFieldOptionsPropertyConfig(),
          },
          {
            label: 'templateBuilder.formFields.optionsLayout',
            selector: '{SELECTOR} .spm_widget_input_checkbox__options-container',
            properties: [{ name: 'spm_options_layout_', getter: getClassByName, setters: [setClass] }],
            fieldId: 'optionsLayout',
            parentFieldId: 'contactProperty',
            isVisible: (items: any[]) => {
              const optionsField = items.find((item: any) => item.properties?.some((p: any) => p.name === 'propertyOptions'));
              const options = optionsField?.properties?.find((p: any) => p.name === 'propertyOptions')?.value;
              return Array.isArray(options) && options.length > 1;
            },
            displayToggle: false,
            ...optionsLayoutFieldConfig,
          },
          {
            label: 'templateBuilder.formFields.showLabel',
            selector: '{SELECTOR} .spm_widget_input_checkbox__container',
            properties: [
              {
                name: 'spm_label_inside',
                getter: (selector: string, name: string) => hasClass(selector, name, { revert: true }),
                setters: [
                  (selector: string, property: Property) => toggleClass(
                    selector,
                    property,
                    {
                      revert: true,
                      callback: () => toggleShowLabelInside(selector, property),
                    },
                  ),
                ],
              },
            ],
            fieldId: 'showLabelInside',
            ...getDisplayFieldConfig('spm_label_inside'),
            displayToggle: false,
          },
          {
            label: 'templateBuilder.formFields.label',
            selector: '{SELECTOR} .spm_widget_input_checkbox__label',
            properties: [{ name: 'content', getter: getContentWithLineBreaks, setters: [setContent] }],
            fieldId: 'label',
            ...getInputVariablesFieldConfig('Libellé', variables.allVariables, false, true),
          },
          {
            label: 'templateBuilder.formFields.mandatoryAcceptance',
            selector: '{SELECTOR} .spm_widget_input_checkbox__container',
            parentFieldId: 'contactProperty',
            isVisible: (items: any[]) => {
              const optionsField = items.find((item: any) => item.properties?.some((p: any) => p.name === 'propertyOptions'));
              const options = optionsField?.properties?.find((p: any) => p.name === 'propertyOptions')?.value;
              return !Array.isArray(options) || options.length === 0;
            },
            properties: [
              {
                name: 'spm_widget_form_required',
                getter: hasClass,
                setters: [
                  toggleClass,
                  (selector: string, property: Property) => saveFormFieldConfig(selector, property, 'mandatory'),
                ],
              },
            ],
            fieldId: 'mandatory',
            ...getDisplayFieldConfig('spm_widget_form_required'),
            enableValue: 'true',
            displayToggle: false,
            allowEmpty: false,
          },
          {
            label: 'templateBuilder.formFields.fieldRequired',
            selector: '{SELECTOR} .spm_widget_input_checkbox__container',
            parentFieldId: 'contactProperty',
            isVisible: (items: any[]) => {
              const optionsField = items.find((item: any) => item.properties?.some((p: any) => p.name === 'propertyOptions'));
              const options = optionsField?.properties?.find((p: any) => p.name === 'propertyOptions')?.value;
              return Array.isArray(options) && options.length > 0;
            },
            properties: [
              {
                name: 'spm_widget_form_required',
                getter: hasClass,
                setters: [
                  toggleClass,
                  (selector: string, property: Property) => saveFormFieldConfig(selector, property, 'mandatory'),
                ],
              },
            ],
            fieldId: 'mandatory',
            ...getDisplayFieldConfig('spm_widget_form_required'),
            enableValue: 'true',
            displayToggle: false,
            allowEmpty: false,
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        label: 'templateBuilder.configs.widgetStyles',
        tabItemType: TemplateStructureEnum.GROUP,
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.formFields.appearanceStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.checkboxSize',
                  selector:
                    '{SELECTOR} .spm_form_field input.spm_widget_input_checkbox__input, '
                    + '{SELECTOR} .spm_form_field input.spm_widget_input_radio__input',
                  properties: [
                    { name: 'width', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'height', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'min-width', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'min-height', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX, 1, 12, 40),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector:
                    '{SELECTOR} .spm_form_field input.spm_widget_input_checkbox__input, '
                    + '{SELECTOR} .spm_form_field input.spm_widget_input_radio__input',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.checkboxCheckedBackground',
                  selector:
                    '{SELECTOR} .spm_form_field input.spm_widget_input_checkbox__input:checked, '
                    + '{SELECTOR} .spm_form_field input.spm_widget_input_radio__input:checked',
                  properties: [
                    { name: 'background', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...getColorFieldConfig(undefined, false, true),
                },
                {
                  label: 'templateBuilder.fields.checkboxCheckmarkColor',
                  selector:
                    '{SELECTOR} .spm_form_field input.spm_widget_input_checkbox__input:checked::after, '
                    + '{SELECTOR} .spm_form_field input.spm_widget_input_radio__input:checked::after',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'background', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...getColorFieldConfig(undefined, false, true),
                },
                {
                  label: 'templateBuilder.fields.checkboxLabelFont',
                  selector:
                    '{SELECTOR} .spm_widget_input_checkbox__options label, '
                    + '{SELECTOR} .spm_widget_input_radio__options label',
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.checkboxItemMargin',
                  selector:
                    '{SELECTOR} .spm_widget_input_checkbox__options, '
                    + '{SELECTOR} .spm_widget_input_radio__options',
                  properties: [
                    { name: 'margin-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'margin-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'margin-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'margin-right', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('margin').options,
                    ...getHorizontalSpacesFieldConfig('margin').options,
                  },
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
    ],
  },
};

export default widgetInputCheckboxConfig;
